const BlankPage: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.5858 2.58579C14.2107 2.21071 13.702 2 13.1716 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L14.5858 2.58579ZM6 20V4H13V7.5C13 8.32843 13.6716 9 14.5 9H18V20H6Z" fill="currentColor" />
  </svg>
);

export default BlankPage;
